<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'
// import './qiankun'

export default {
  data () {
    return {
    }
  },
  created() {
    // console.log(window.location.href);
    let fullHref = window.location.href;
    if(fullHref.split("forget")[1]) {
      console.log('进来了')
      console.log(fullHref.split("forget")[1])
      // next({ path: 'forget', query: { code: fullHref.split("forget")[1]}})
      this.$router.push({
        name:'forget',
        params: { code: fullHref.split("forget")[1]}
      })
    }

    console.log(window.location.href);
  },
  computed: {
    locale () {
      // 只是为了切换语言时，更新标题
      const { title } = this.$route.meta
      title && (setDocumentTitle(`${i18nRender(title)} - ${domTitle}`))

      return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    }
  }
}

</script>
<style>
.vue-directive-image-previewer {
  z-index: 1111111111!important;
}
</style>
